import styled from "styled-components";

export const StyledBarGraph = styled.div`
  .recharts-default-legend {
    display: flex;
    justify-content: center;
    gap: 20px;
    li {
      margin-right: 0 !important;
    }
  }

  .custom-tooltip {
    background-color: #fff;
    padding: 8px 16px;
    border-radius: 4px;
    border: 1px solid #ccc;
    text-align: start;
    .label {
      font-size: 14px;
      font-weight: 700;
    }
    .wrap {
      display: flex;
      flex-flow: column nowrap;
      & > p {
        font-size: 12px;
        font-weight: 100;
      }
    }
  }

  .graph-wrap {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    gap: 16px;
    .button-wrap {
      width: max-content;
      margin: 0 auto;
      overflow: hidden;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      border: 1px solid #ccc;
      button {
        cursor: pointer;
        padding: 6px 9px;
        font-size: 12px;
        color: #333;
        display: flex;
        gap: 4px;
        align-items: center;
        border: none;
        outline: none;
        background: transparent;
        opacity: 0.4;
        .circle {
          width: 9px;
          height: 9px;
          border-radius: 50%;
          display: block;
        }
        &.active {
          opacity: 1;
        }
      }
    }
  }
`;
